'use client';

import { useAuth } from '@/auth/AuthProvider';

export default function useV2Auth() {
    const auth = useAuth();

    return {
        ...auth,
        init: async () => {
            await auth.init();
        },
        logout: () => {
            void auth.logout();
        },
    };
}
